import React, { useState } from "react";
import { X, Sparkles } from "lucide-react";
import { useAcademy } from "./AcademyContext";

const AVATAR_SRC = "/academy-avatar-dottor-feliciano.jpg";

// Avatar "non invasivo": un pulsante circolare piccolo in basso a destra,
// sopra il menu mobile ma senza occupare l'header già affollato. Spiega la
// pagina corrente con testo predefinito (nessuna chiamata AI esterna) e, se
// disponibile, propone il tour guidato passo-passo.
export default function AvatarAssistant() {
  const { content, assistantOpen, openAssistant, closeAssistant, startTour } = useAcademy();
  const [imgOk, setImgOk] = useState(true);
  const guide = content?.guide;
  const hasTour = (content?.tour_steps || []).length > 0;

  return (
    <>
      <button
        type="button"
        onClick={() => (assistantOpen ? closeAssistant() : openAssistant())}
        className="fixed bottom-24 right-4 z-40 grid h-14 w-14 place-items-center overflow-hidden rounded-full border-2 border-white bg-navy shadow-lg transition-transform hover:scale-105 lg:bottom-6 lg:right-6"
        aria-label="Apri l'assistente DF Academy"
        data-testid="academy-avatar-button"
      >
        {imgOk
          ? <img src={AVATAR_SRC} alt="" className="h-full w-full object-cover" onError={() => setImgOk(false)} />
          : <span className="font-heading text-lg font-bold text-white">DF</span>}
      </button>

      {assistantOpen && (
        <div className="fixed inset-x-3 bottom-[10.5rem] z-40 rounded-2xl bg-white p-4 shadow-2xl ring-1 ring-hairline sm:inset-x-auto sm:bottom-24 sm:right-6 sm:w-80" data-testid="academy-assistant-panel">
          <div className="flex items-start gap-3">
            <div className="h-10 w-10 shrink-0 overflow-hidden rounded-full bg-navy">
              {imgOk && <img src={AVATAR_SRC} alt="" className="h-full w-full object-cover" />}
            </div>
            <div className="min-w-0">
              <div className="font-heading text-sm font-bold text-navy">Dott. Dario Feliciano</div>
              <div className="text-xs text-slate-400">Assistente DF Academy</div>
            </div>
            <button type="button" onClick={closeAssistant} className="ml-auto shrink-0 rounded-full p-1 text-slate-400 hover:bg-slate-100" aria-label="Chiudi"><X className="h-4 w-4" /></button>
          </div>
          <div className="mt-3 max-h-[40vh] overflow-y-auto text-sm leading-relaxed text-slate-600">
            {guide?.purpose
              ? <p>{guide.purpose}</p>
              : <p>Guida non ancora disponibile per questa pagina: sto ancora scrivendo il materiale, torna a trovarmi presto.</p>}
            {guide?.when_to_use && <p className="mt-2">{guide.when_to_use}</p>}
          </div>
          {hasTour && (
            <button type="button" onClick={startTour} className="mt-3 flex w-full items-center justify-center gap-2 rounded-lg bg-navy px-3 py-2.5 text-sm font-semibold text-white hover:bg-navy/90" data-testid="academy-start-tour">
              <Sparkles className="h-4 w-4" /> Avvia tour guidato di questa pagina
            </button>
          )}
        </div>
      )}
    </>
  );
}
